import { defaultIconProps, IconProps } from './IconProps';

export const IconArrowUpDownV2: import('react').FC<IconProps> = ({ size = 18, color = '#344054', strokeWidth = '1.5', ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M4.83333 1.33331V14.6666M4.83333 14.6666L1.5 11.3333M4.83333 14.6666L8.16667 11.3333M13.1667 14.6666V1.33331M13.1667 1.33331L9.83333 4.66665M13.1667 1.33331L16.5 4.66665"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconArrowUpDownV2.defaultProps = defaultIconProps;
